import { Injectable, inject } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ConnectivityService } from '../services/connectivity.service';

/**
 * Tracks "server unreachable" scenarios even when the device is technically online.
 * This drives a global banner shown on all pages (Tabs layout).
 */
@Injectable()
export class ConnectivityInterceptor implements HttpInterceptor {
  private readonly connectivity = inject(ConnectivityService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          // Any successful HTTP response implies server reachable.
          this.connectivity.markServerReachable();
        }
      }),
      catchError((error: HttpErrorResponse) => {
        const status = error?.status ?? 0;
        // status=0 is "network error / CORS / unreachable"
        // 503/504 are effectively unreachable for the user
        if (status === 0 || status === 503 || status === 504) {
          this.connectivity.markServerUnreachable(error?.message || 'Unable to reach server');
        }
        return throwError(() => error);
      }),
    );
  }
}

